<template>
  <div class="intro-container">
    

    <!-- <div class="reveal"></div> -->
    <div class="shield-svg">
      <img src="../assets/animatedSVG/arrowgif_1x.gif" alt="">
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ShieldIntro",
  created() {
    setTimeout(() => {
      console.log('redirect to shield page');
      // this.$router.push({ path: '/shield' });
      window.location.href="http://shield-maintenance.com/shield";
 },5000);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";
@import "./src/stylesheets/ui/_animations.scss";

.intro-container {
  display: flex;

  @media screen and (max-width: $medium-bp) {
    flex-direction: column;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    flex-direction: row;
  }

  @media screen and (min-width: $medium-bp+0.1) and (max-width: 1024px) and (min-height: 1025px) {
    flex-direction: column;
  }
}


</style>
